"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.HINT = exports.MAIN_TEXT = exports.CENTER_DIV = exports.WRAPPER = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    WRAPPER = function WRAPPER(a) {
  var b = a.darkTheme;
  return (0, _cxs["default"])({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    height: "100vh",
    width: "100vw",
    background: b ? _vars.COLOURS.grey.nightRider : _vars.COLOURS.mono.white,
    zIndex: 1e3,
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  });
};

exports.WRAPPER = WRAPPER;
var CENTER_DIV = (0, _cxs["default"])({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center"
});
exports.CENTER_DIV = CENTER_DIV;

var MAIN_TEXT = function MAIN_TEXT(a) {
  var b = a.darkTheme;
  return (0, _cxs["default"])({
    fontSize: "20px",
    color: b ? _vars.COLOURS.mono.white : _vars.COLOURS.mono.black
  });
};

exports.MAIN_TEXT = MAIN_TEXT;

var HINT = function HINT(a) {
  var b = a.darkTheme;
  return (0, _cxs["default"])({
    fontSize: "15px",
    margin: "20px",
    color: b ? _vars.COLOURS.mono.white : _vars.COLOURS.mono.black
  });
};

exports.HINT = HINT;